var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('bread-crumbs',{attrs:{"items":_vm.breadcrumbs}}),_c('h2',{staticClass:"text-h5 font-weight-bold mb-4"},[_vm._v(" Proyectos en "+_vm._s(_vm.area.nombre)+" ")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.proyectos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }